import { Alert, Button } from "reactstrap";
import { useState } from "react";

import { Person } from "../../types/GlobalInterfaces";
import PermissionList from "../CRM/PermissionList";
import AppSpinner from "../../elements/AppSpinner";
import AppDrawer from "./AppDrawer";

interface Props {
  open: boolean;
  onClose: () => void;
  newUser: Person;
  type: string;
  permissions: any;
  assignOwnership: (payload: {
    newUserID: string;
    permissionProfile: any;
    onSuccess: () => void;
  }) => void;
  assigningOwnership: boolean;
  assignOwnershipError: string;
}

const TransferOwnershipDrawer = ({
  open,
  onClose,
  newUser,
  type,
  permissions,
  assignOwnership,
  assigningOwnership,
  assignOwnershipError,
}: Props) => {
  const [selectedPermission, setSelectedPermission] = useState<any>(null);

  const handleClose = () => {
    setSelectedPermission(null);
    onClose();
  };

  const transferOwnership = () => {
    if (newUser?.id === undefined) {
      return;
    }

    assignOwnership({
      newUserID: newUser.id,
      permissionProfile: selectedPermission,
      onSuccess: handleClose,
    });
  };

  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      headerTitle={`Transferring ${type} Ownership`}
      headerOptions={
        <Button
          color="danger"
          size="sm"
          onClick={transferOwnership}
          disabled={!selectedPermission || assigningOwnership}
          style={{ width: 80 }}
        >
          {assigningOwnership ? (
            <AppSpinner style={{ height: 16, width: 16 }} />
          ) : (
            "Transfer"
          )}
        </Button>
      }
      body={
        <>
          {assignOwnershipError && (
            <Alert color="danger" className="mb-4">
              {assignOwnershipError}
            </Alert>
          )}
          <h4 className="mb-4">
            New {type} Owner:{"  "}
            {/* TODO: Make this name a link/drawer to more information about the user. */}
            <span
              style={{
                color: "var(--primary)",
                cursor: "pointer",
                marginLeft: 4,
              }}
            >
              {newUser?.Name || newUser?.PrimaryContactEmail}
            </span>
          </h4>
          <h4>New Permissions:</h4>
          <PermissionList
            permissions={permissions}
            selectedPermission={selectedPermission}
            onChange={setSelectedPermission}
            filterOwner
          />
        </>
      }
    />
  );
};

export default TransferOwnershipDrawer;
